<template>
    <div class="mt-2">
        <select v-model="selected" @change="submit" class="form-control" v-bind:disabled="submitted">
            <option v-for="option in options" v-bind:value="option.value">
                {{ option.text }}
            </option>
        </select>
    </div>
</template>

<script>
    // import VueMonthlyPicker from 'vue-monthly-picker';

    export default {
        props: ['month'],
        data() {
            return {
                selected: 6,
                submitted: false,
                options: [
                    { value: 3, text: Lang.choice('messages.stats.months', 3, { count: 3}) },
                    { value: 6, text: Lang.choice('messages.stats.months', 6, { count: 6}) },
                    { value: 12, text: Lang.choice('messages.stats.months', 12, { count: 12}) },
                    { value: 24, text: Lang.choice('messages.stats.months', 24, { count: 24}) },
                ]
            }
        },

        created() {
            this.selected = this.month;
        },

        methods: {
            submit() {
                this.submitted = true;

                window.location.href = window.location.href.split('?')[0] +
                    '?months=' + this.selected;
            }
        }
    }
</script>
